import { useEffect, useState, useRef } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { connect, useStore } from "react-redux";
import { useHistory } from "react-router-dom";
import useMedia from "use-media";
import commonUtil from "../../common/commonUtil";
import messageConst from "../../const/messageConst";
import { GetPublicHoliday } from "../../hooks/getPublicHoliday";
import "../../resources/css/common/calendar.css";
import cross from '../../resources/icons/ico_X.svg';
import circle from '../../resources/icons/ico_circle.svg';
import { Image } from "../atoms/image";
import { Label } from '../atoms/label';
import { ModalClose } from "../atoms/modalClose";
import './../../resources/css/popup/golf_facility_calendar_popup.css';
import './../../resources/css/soloReserve/golfSoloSearch.css';
const GolfSoloPlanCalendarContainer = (props) => {
    const { state,
        onClickCalendarMove,
        onClickClosePlanCalendarWindow,
        soloCourse,
        setSoloCourse,
        golfSoloSearchData,
        setGolfSoloSearchData,
        login,
        soloKaiinken,
    } = props;

    // 祝日取得用カスタムフック
    const { getHoliday } = GetPublicHoliday();

    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const [activeStartDate, setActiveStartDate] = useState(null);
    const [maxDate, setMaxDate] = useState(null);
    const [minDate, setMinDate] = useState(null);
    const firstDate = useRef(null);
    const count = useRef(0);
    const popupFlg = state.planCalendarPopup;
    const calendarStartDate = state.calendarStartDate;
    const courseId = useRef(null);
    const dataList = state.planVacancyInfo.vacancyDateList;
    const store = useStore();
    const history = useHistory();
    const [latestFlg, setLatestFlg] = useState(false);

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);


    useEffect(() => {
        // 次へ表示ボタンに関数登録
        const nextElm = document.getElementsByClassName("react-calendar__navigation__arrow react-calendar__navigation__next-button");
        nextElm[1].addEventListener("click", nextDate);

        // 戻る表示ボタンに関数登録
        const prevElm = document.getElementsByClassName("react-calendar__navigation__arrow react-calendar__navigation__prev-button");
        prevElm[1].addEventListener("click", prevDate);
    }, [])

    // プレー日欄に表示する日付取得(ポップアップレンダリング時)
    useEffect(() => {
        if (popupFlg) {
            document.getElementById("calendarDecision").disabled = false;
        }

        // カレンダー表示起点日
        let startDate = new Date();

        let selectDate = new Date();
        selectDate.setDate(selectDate.getDate() + 3);

        if (calendarStartDate) {
            // カレンダーの開始日付が指定されていた場合
            // カレンダー選択項目
            startDate = calendarStartDate;
            setActiveStartDate(calendarStartDate);
        } else if (store.getState().playDate1) {
            //storeにdateが入っていればそちらを使う
            let checkIn = new Date(store.getState().playDate1);
            startDate = checkIn;
            // カレンダー選択項目
            setActiveStartDate(checkIn);
        } else {
            // カレンダー選択項目
            setActiveStartDate(selectDate);
        }

        let now = new Date();
        let d1Month = startDate.getFullYear() * 12 + startDate.getMonth();
        let d2Month = now.getFullYear() * 12 + now.getMonth();
        let diffMonth = d1Month - d2Month;
        count.current = diffMonth;

        // カレンダー最大選択範囲
        let maxDate = new Date();
        maxDate.setFullYear(maxDate.getFullYear() + 1);
        setMaxDate(maxDate);

        // カレンダー最小選択範囲
        let minDate = new Date();
        minDate.setDate((minDate.getDate() + 3));
        setMinDate(minDate);

        let first = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 3);
        firstDate.current = first;

        courseId.current = state.courseId;
    }, [popupFlg]);

    // 次へ表示制御
    const nextDate = () => {
        let activeDate = new Date();
        activeDate.setDate(1);
        count.current += 1;
        activeDate.setMonth(activeDate.getMonth() + count.current);
        setActiveStartDate(activeDate);

        let date = new Date();
        date.setDate(25);
        date.setMonth(date.getMonth() + count.current - 1);

        let startDate
        const current = firstDate.current
        if (current >= date) {
            startDate = new Date(current);
        } else {
            // チェックイン
            startDate = new Date(date);
        }

        let y = startDate.getFullYear();
        let m = startDate.getMonth() + 1;
        let d = startDate.getDate();

        if (m < 10) m = `0${m}`
        if (d < 10) d = `0${d}`

        // リクエスト情報の格納　タイミング上storeからの直接取得
        const searchData = store.getState().golfSoloSearchData;
        const req = {
            playDate: `${y}-${m}-${d}`,
            golfCourseId: searchData.golfCourseId,
            membershipAuthID: searchData.memberShipAuth,
            searchType: 1,
            kaiinKind:searchData.kaiinKind,
            planId: searchData.planId,
            planInfo: [{ planId: searchData.planId, planName: searchData.planName }],
        }
        onClickCalendarMove(req);
    }

    // 戻る表示制御
    const prevDate = () => {
        let activeDate = new Date();
        activeDate.setDate(1);
        count.current -= 1;
        if (count.current < 0) {
            count.current = 0;
            return;
        }
        activeDate.setMonth(activeDate.getMonth() + count.current);
        setActiveStartDate(activeDate);

        let date = new Date();
        date.setDate(25);
        date.setMonth(date.getMonth() + count.current - 1);

        // チェックイン
        let startDate;
        const current = firstDate.current
        if (current >= date) {
            startDate = new Date(current);
        } else {
            // チェックイン
            startDate = new Date(date);
        }

        let y = startDate.getFullYear();
        let m = startDate.getMonth() + 1;
        let d = startDate.getDate();

        if (m < 10) m = `0${m}`
        if (d < 10) d = `0${d}`

        // リクエスト情報の格納　タイミング上storeからの直接取得
        const searchData = store.getState().golfSoloSearchData;
        const req = {
            playDate: `${y}-${m}-${d}`,
            golfCourseId: searchData.golfCourseId,
            membershipAuthID: searchData.memberShipAuth,
            searchType: 1,
            kaiinKind:searchData.kaiinKind,
            planId: searchData.planId,
            planInfo: [{ planId: searchData.planId, planName: searchData.planName }],
        }
        onClickCalendarMove(req);
    }

    // 日付選択
    const onClickTargetDay = (val, event) => {

        // チェックイン
        const checkInDate = new Date(val);
        const startDate = commonUtil.getStringFromDate(checkInDate, "yyyy-MM-dd");
        const today = commonUtil.getStringFromDate(new Date(), "yyyy-MM-dd");
        const within3 = commonUtil.getNights(today, startDate, "-");
        if (within3 < 3) {
            setLatestFlg(true);
        } else {
            setLatestFlg(false);

            // 「空きなし」「対象外日」は遷移させない
            if (!dataList) return
            const targetDate = commonUtil.getStringFromDate(new Date(val), "yyyy-MM-dd");
            const vacancyMark = dataList.find(value => {
                if (commonUtil.getStringFromDate(new Date(value.riyoDate), "yyyy-MM-dd") === targetDate) {
                    return value.mark
                }
            }).mark
            if (vacancyMark !== undefined && vacancyMark !== "○") {
                return
            }

            // リクエスト情報の格納
            let newGolfSoloSearchData = {
                ...golfSoloSearchData,
                playDate: targetDate,
                planId: state.planVacancyInfo.planId,
            }
            setGolfSoloSearchData(newGolfSoloSearchData);

            // 画面遷移
            history.push("/reserve/golf/soloStartTime");
        }
    };

    // カレンダーの月表示を大きくするための関数(スマホ版)
    const layoutChangeOfMonthMobile = (date) => {

        const label = document.getElementsByClassName("react-calendar__navigation__label__labelText--from")[1];
        const y = date.getFullYear();
        const m = date.getMonth() + 1;

        if (label) {
            label.style.width = "100%";
            label.style.padding = "0";
            label.innerHTML = `${y}年<span class='month-view'> ${m}月</span>`;
        }
    };

    // 決定ボタン押下時
    const decision = () => {
        // 二度押し防止
        document.getElementById("calendarDecision").disabled = true;
    };

    const onClickClose = () => {
        // ポップアップの表示・非表示用更新関数
        onClickClosePlanCalendarWindow();
    }

    //日付の内容を出力
    const getTileContent = (calendar) => {

        // 日付フォーマット処理
        const targetDate = commonUtil.getStringFromDate(new Date(calendar.date), "yyyy-MM-dd");
        // タイルに表示する内容の初期化
        let vacancy = "";
        if (dataList) {
            dataList.forEach(value => {
                if (commonUtil.getStringFromDate(new Date(value.riyoDate), "yyyy-MM-dd") == targetDate) {
                    vacancy = value.mark;
                }
            })
        }

        // タイルに表示する内容を返却
        return (
            <div className="soloSearch_calendarCell">
                <Label
                    className={
                        vacancy == "○" ? "soloSearch_circle" :
                            vacancy == "×" ? "soloSearch_cross" :
                                "soloSearch_occupy"
                    }
                />
            </div>
        );
    }

    const getbackGroundColor = (activeStartDate, date, view) => {

        // 日付フォーマット処理
        const targetDate = commonUtil.getStringFromDate(new Date(date), "yyyy-MM-dd");
        // タイルに表示する内容の初期化
        let vacancy = "";
        let right = "";
        if (dataList) {
            dataList.forEach(value => {
                if (commonUtil.getStringFromDate(new Date(value.riyoDate), "yyyy-MM-dd") == targetDate) {
                    vacancy = value.mark;
                }
            })
        }

        // タイル背景を返却
        let backGroundColor = "";
        backGroundColor = vacancy === "○" ?
            "white" : "right_none";
        return (getHoliday(activeStartDate, date, view) + " " + backGroundColor);
    }

    const closeLatestModal = () => {
        setLatestFlg(false);
    }

    return (
        <>
            <div className={popupFlg ? "popupIsShow" : "popup"} id="js-popup">
                <div className="popupInner">
                    <ModalClose divStyle={"modalClose"} svgStyle={"modalSvg"} onClick={onClickClose} />
                    <div className="popupInnerText" >
                        <h4 className="golfSoloPopupInnerFacility" >
                            {state.popupTitle}
                        </h4>
                    </div>
                    {isMobilePhone ?
                        (<Calendar
                            activeStartDate={activeStartDate}
                            locale={"ja-JP"}
                            calendarType={"US"}
                            maxDate={maxDate}
                            minDate={minDate}
                            value={null}
                            showDoubleView={false}
                            onClickDay={(val, event) => onClickTargetDay(val, event)}
                            formatDay={(locale, date) => date.getDate()}
                            tileClassName={({ activeStartDate, date, view }) => getbackGroundColor(activeStartDate, date, view)}
                            formatMonthYear={(locale, date) => layoutChangeOfMonthMobile(date)}
                            nextLabel={""}
                            prevLabel={""}
                            next2Label={null}
                            prev2Label={null}
                            tileContent={getTileContent}
                        />
                        ) :
                        (<Calendar
                            activeStartDate={activeStartDate}
                            locale={"ja-JP"}
                            calendarType={"US"}
                            maxDate={maxDate}
                            minDate={minDate}
                            value={null}
                            showDoubleView={false}
                            onClickDay={(val, event) => onClickTargetDay(val, event)}
                            formatDay={(locale, date) => date.getDate()}
                            tileClassName={({ activeStartDate, date, view }) => getbackGroundColor(activeStartDate, date, view)}
                            formatMonthYear={(locale, date) => layoutChangeOfMonthMobile(date)}
                            nextLabel={""}
                            prevLabel={""}
                            next2Label={null}
                            prev2Label={null}
                            tileContent={getTileContent}
                        />
                        )}
                    <div className="soloSearch_descriptionArea">
                        <div className="soloSearch_markDescription">
                            <div className="soloSearch_tableImage">
                                <Image image={circle} className="soloSearch_mark" />
                                <Label label={":空きあり"} className="soloSearch_usageGuide" />
                            </div>
                            <div className="soloSearch_tableImage" >
                                <Image image={cross} className="soloSearch_mark" />
                                <Label label={":空きなし、対象外日"} className="soloSearch_usageGuide" />
                            </div>
                        </div>
                        <div className="soloSearch_calendarDescription">
                            <Label label={"※本日・明日・明後日のご予約はお電話にてご連絡ください"} className="soloSearch_usageGuide" />
                        </div>
                    </div>
                </div>
                <div className="blackBackground" id="js-black-bg"></div>
            </div >
            <div className={latestFlg ? "golf_latest3Popup" : "popup"} id="js-popup">
                <div className="golf_latest3PopupInner">
                    <Label label={messageConst.WITHIN_3_DATE_MESSAGE} className="golf_latest3Label" />
                    {/* <Label label={facilityTel} className="golf_latest3TelLabel" /> */}
                    <button id="calendarDecision" className="golfCloseLatestModalBtn" onClick={closeLatestModal}>閉じる</button>
                </div>
                <div className="golf_latest3PopupblackBackground" id="js-black-bg"></div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        soloCourse: state.soloCourse,
        login: state.login,
        soloKaiinken: state.soloKaiinken,
        golfSoloSearchData: state.golfSoloSearchData,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setGolfSoloSearchData: (item) => {
            dispatch({ type: "GOLF_SOLO_SEARCH_DATA", payload: { golfSoloSearchData: item } })
        },
        setSoloCourse: (item) => {
            dispatch({ type: "SOLO_COURSE", payload: { soloCourse: item } })
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(GolfSoloPlanCalendarContainer);
